import {
  createTypedIntl,
  keyOf,
  type TranslationKey,
  type TranslationKeyFn,
} from "@voltalis/frontend-tooling/i18n/runtime";

import { keys } from "@/.generated/i18n/i18n-keys.generated";

export { keyOf, type TranslationKey, type TranslationKeyFn };

export const useTypedIntl = createTypedIntl(keys);

export type TypedIntl = ReturnType<typeof useTypedIntl>;
export type TranslationKeys = typeof keys;
